module.exports = __webpack_public_path__ + "static/media/Liberia.a13af05e.png";